// A visited host's parked bike (bike plan 3, task 8): the owner's layered BikeSprite, read-only, in the host's design
// and facing the way it was left, placed and sized through the ground line like BikeController's parked bike.
import { BikeSprite } from './BikeSprite.js';
import { parkedBikeOutdoor } from './carCatalog.mjs';
import { parkedFacing8 } from './dir8.mjs';

// b: the visit view's bike {parked_x, parked_y, parked_facing, design}; x / defaultY: the scene's default spot (a
// parked centre); tip: the shared hover label.
export function hostParkedBike(scene, type, b, { x, defaultY, profile, tip }) {
  const rig = scene.cache.json.get('bike_rig');
  const { y, h } = parkedBikeOutdoor(type, { storedY: b.parked_y, defaultY }, profile, rig);
  const bike = new BikeSprite(scene, b.parked_x ?? x, y, {
    type, design: b.design ?? null, parked: true, dir8: parkedFacing8(b.parked_facing),
  }).setDisplayHeight(h).setDepth(1)
    .setInteractive();   // hover only — visiting stays read-only, no click action
  bike.on('pointerover', () => tip.setPosition(bike.x, bike.y - h / 2 - 6).setVisible(true));
  bike.on('pointerout', () => tip.setVisible(false));
  return bike;
}
